import React from 'react';
import {Chip} from '@mui/material';
import {estImporte} from './echangeScenarioRules';

/** Badge « importé » d'un scénario issu d'un export (table, page scénario, atelier) ; rien si le scénario n'est pas importé. */
function BadgeImporte({simulation, sx}) {
    if (!estImporte(simulation)) return null;
    return <Chip size="small" label="importé" data-testid="badge-importe" sx={{bgcolor: '#E8EEFA', color: '#213067', fontWeight: 700, ...sx}}/>;
}

export default BadgeImporte;
